import { render, staticRenderFns } from "./salesFreightBillDetails.vue?vue&type=template&id=3bfc2213&scoped=true"
import script from "./salesFreightBillDetails.vue?vue&type=script&lang=js"
export * from "./salesFreightBillDetails.vue?vue&type=script&lang=js"
import style0 from "./salesFreightBillDetails.vue?vue&type=style&index=0&id=3bfc2213&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bfc2213",
  null
  
)

export default component.exports